import { DataPipe } from './../../pipes/data.pipe';
import { Andamento } from './../../models/Andamento';
import { forEach } from '@angular/router/src/utils/collection';
import { filter } from 'rxjs/operators';
import { Agente } from './../../models/agente'
import { Component, OnInit, Injectable, Output, EventEmitter, Input, ViewChild, PipeTransform } from '@angular/core'
import { DataService } from 'app/services/data-service'
import { Solicitacao } from 'app/models/Solicitacao'
import { ToastsManager } from 'ng2-toastr';
import { FormBuilder, FormGroup, FormControl, Validators, FormArray } from '@angular/forms'
import { FiltroService } from '../../services/filtros.service'
import { Lightbox, LightboxConfig } from 'ngx-lightbox'
import { ApiService, URLS } from 'app/services/api.service'
import { environment } from 'environments/environment';
import { Unidades } from 'app/models/Unidades';
import { DespachoTipo } from 'app/models/DespachoTipo';
import { UserStorageService } from 'app/services/user-storage.service';
import { AndamentoTipo } from 'app/models/AndamentoTipo';
import { IntervalObservable } from "rxjs/observable/IntervalObservable";// não apagar
import { EnvolvimentosTipo } from 'app/models/EnvolvimentosTipo';
import { SolicitacaoFoto } from 'app/models/SolicitacaoFoto';
import { DomSanitizer } from '@angular/platform-browser';
import { AndamentoFoto } from 'app/models/AndamentoFoto';
import { ProvidenciaTipo } from 'app/models/ProvidenciaTipo';
import { AndamentoFechamentoTipo } from 'app/models/AndamentoFechamentoTipo';
import { AndamentoFechamentoMotivo } from 'app/models/AndamentoFechamentoMotivo';
import { isNullOrUndefined } from 'util';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { HttpErrorResponse } from '@angular/common/http';
import * as $ from 'jquery';
import { DocumentRef } from '@agm/core/utils/browser-globals';
import * as moment from "moment";
import { DatePipe } from '@angular/common';
import { Observable, ReplaySubject } from 'rxjs';
import { definirNomeAndamentosTiposPorSituacao } from '../utils/definir_nome_andamentos_tipo';
import { TransformaObjetoEmListaPipe } from 'app/pipes/transformaObjetoEmLista.pipe';
import { FormularioLateral } from 'app/models/FormularioLateral';
import { PapeletaAgente } from 'app/models/PapeletaAgente';
import { ActivatedRoute } from '@angular/router';
import { UnidadeFiltro } from 'app/models/UnidadeFiltro';
import { DataHoraHelp } from '../utils/data_hora_help';
import { DespachoService } from 'app/services/despacho.service';
import { DespachoNoLocalService } from 'app/services/despacho-no-local.service';
import { DespachoAtenderService } from 'app/services/despachoAtender.service';
import { DespachoFecharService } from 'app/services/despachoFechar.service';
import { DespachoDevolverService } from 'app/services/despachoDevolver.service';
import { DespachoNaoAtenderService } from 'app/services/despachoNaoAtender.service';
// import { AndamentosDaSolicitacao } from 'app/services/andamentos-da-solicitacao';

@Injectable()
@Component({
  selector: 'app-formulario-lateral',
  templateUrl: './formulario-lateral.component.html',
  styleUrls: ['./formulario-lateral.component.scss'],
  providers: [DatePipe, DataHoraHelp, DespachoService, DespachoNoLocalService,
    DespachoAtenderService, DespachoFecharService, DespachoDevolverService, DespachoNaoAtenderService]
})
export class FormularioLateralComponent implements OnInit {

  @Output() respostaFiltro = new EventEmitter();
  @Output() statusFormLateral = new EventEmitter<boolean>();
  @Output() statusSalvarProvidencia = new EventEmitter<boolean>();

  public slt: Solicitacao = new Solicitacao();
  public und: Unidades = new Unidades();
  public agente: Agente = new Agente();
  public formularioLateral: any = { status: false };
  agenteFormulario = null
  agenteFormularioProvidenciaResposta = null
  agenteFormularioProvidencia = null
  unidadeFormularioProvidencia = null

  solicitacao = null
  despachos = null
  andamentos = null
  envolvidos = null
  historicos: any = []

  despachoForm: FormGroup
  labelTipoEncaminhamento: string = ''
  providenciaForm: FormGroup
  fechamento: boolean = false
  desabilitarSalvar: boolean = false
  providenciaSalva: boolean = false
  tipoDespacho
  unidades
  agente_id
  providencias
  private _album = [];
  agenteForm: FormGroup
  envolvidoForm: FormGroup
  filtroForm: FormGroup
  despachosTipos
  providenciasTipos
  andamentosTipos
  listaAndamentosTipos
  andamentosFechamentosTipos
  andamentosFechamentosMotivos
  tiposEnvolvimento
  usuarioLogado: any;

  exibirSpinnerListaDeDespacho: boolean = false
  exibirSpinnerBuscarAgente: boolean = false
  exibirSpinnerBuscarAgenteProvidencia: boolean = false

  exibirSpinnerListaDeAndamento: boolean = false
  exibirSpinnerListaDeEnvolvido: boolean = false
  exibirSpinnerListaDeHistorico: boolean = false

  exibirSpinnerDeFotoSolicitacao: boolean = false
  exibirSpinnerDeFotoAndamento: boolean = false

  fotos

  exibirFormularioDespacho = false;
  exibirFormularioProvidencia = false;
  exibirFormularioEnvolvido = false;

  exibirSpinnerFormularioDeAndamento = false;

  atender = false;
  no_local = false;
  nao_atender = false;
  despachar = false;
  reiterar = false;
  cancelar = false;
  fechar = false;
  devolver = false;
  reclassificar = false;
  data_ultimo_andamento = '';
  exibirCheckBoxDespachar = false;
  exibirCheckBoxExecutarFechamento = false;
  exibirDropdownProvidencia = false;
  dataHoraDoSistema;
  retorno: boolean = true;
  validado: boolean = false;
  dataDoFormulario = '';
  fotosDoFormulario = [''];
  foto = '';
  typeFoto = '';
  habilitarCampoPlaca = true;
  PlacaMask = '';
  ValidaPlaca = false;
  validador: boolean = false;
  messagemDeRetornoDataInicial: boolean = false;
  messagemDeRetornoDataFim: boolean = false;
  agentePronto
  statusDoAgente: string;
  mostrarSupervisoes: boolean = false;
  textoBotaoSupervisao: string = 'Exibir Supervisões';
  textoBotaoPronto: string = '';
  inputPlaca;
  papeleta: PapeletaAgente[];
  despachoDaProvidencia: boolean = false;
  unidadeAutorizadaAbrirFecharPronto: boolean = false;
  perfilAutorizadoAbrirFecharPronto: boolean = false;

  listaDeAndamentos = [];

  @ViewChild('tabset')

  tabset: any;

  productForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private fb2: FormBuilder,
    private dataService: DataService,
    private fb: FormBuilder,
    private filtroService: FiltroService,
    public toastr: ToastsManager,
    private _lightbox: Lightbox,
    private _lightboxConfig: LightboxConfig,
    private apiService: ApiService,
    private userStorage: UserStorageService,
    private sanitizer: DomSanitizer,
    private pipe: DataPipe,
    private data_hora_help: DataHoraHelp,
    private pipeTransformaArrayDeObjetosEmString: TransformaObjetoEmListaPipe,
    private despachoService: DespachoService,
    private despachoNoLocalService: DespachoNoLocalService,
    private despachoAtenderService: DespachoAtenderService,
    private despachoNaoAtenderService: DespachoNaoAtenderService,
    private despachoFecharService: DespachoFecharService,
    private despachoDevolverService: DespachoDevolverService,
  ) {

    this.productForm = this.fb2.group({
      name: '',
      placas: this.fb2.array([Validators.minLength(7)]),
    });

    // _lightboxConfig.showRotate = true;
    // _lightboxConfig.enableTransition = false;
    (_lightboxConfig as any).enableTransition = false;
    this.tipoDespacho = this.filtroService.tipoDespacho;
    //this.providencias = this.filtroService.providenciaRealizada
  }



  ngOnInit() {
    $.getScript('./assets/js/customizer.js');

    this.dataHoraDoSistema = moment(new Date()).format('YYYY-MM-D HH:mm:ss');
    this.usuarioLogado = this.userStorage.getUser();

    if (this.usuarioLogado && this.usuarioLogado.roles) {
      this.filtrarPerfilFecharAbrirPronto(this.usuarioLogado.roles);
    }

    this.dataService.currentUnidades.subscribe(unidade => {
      this.und = unidade;
    });

    this.dataService.currentAgente.subscribe(agente => {
      this.agente = agente;

      if (this.agente && this.agente.pronto === true) {
        this.agentePronto = 'Pronto';
      } else {
        this.agentePronto = '';
      }
    });

    this.dataService.currentFormulario.subscribe(st => {
      this.formularioLateral = st;
    });

    this.dataService.currentMessage.subscribe((slts: any) => {
      if (!slts || !slts.protocolo) {
        return;
      }

      this.slt = slts || new Solicitacao();

      if (!slts || !slts.protocolo) {
        this.solicitacao = null;
        this.andamentos = [];
        this.envolvidos = [];
        this.despachos = [];
        this.historicos = [];
        return;
      }

      this.solicitacao = slts;
      this.andamentos = Array.isArray(slts.andamento) ? slts.andamento : [];
      // console.log("ANDAMENTOS:", this.andamentos);
      this.envolvidos = Array.isArray(slts.envolvido) ? slts.envolvido : [];
      this.despachos = Array.isArray(slts.despacho) ? slts.despacho : [];

      if (this.andamentos.length > 0) {
        const ultimoAndamento = this.andamentos[this.andamentos.length - 1];

        if (ultimoAndamento.andamentos_tipos) {
          this.slt.situacao = ultimoAndamento.andamentos_tipos.nome;
        }
      } else if (!this.slt.situacao) {
        this.slt.situacao = 'Abrir';
      }

      this.slt.situacaoView = definirNomeAndamentosTiposPorSituacao(this.slt.situacao);

      this.historicos = [...this.andamentos].sort((a, b) => {
        return Number(new Date(a.created_at)) - Number(new Date(b.created_at));
      });

      this.exibirSpinnerListaDeDespacho = false;
      this.exibirSpinnerListaDeAndamento = false;
      this.exibirSpinnerListaDeEnvolvido = false;
      this.exibirSpinnerListaDeHistorico = false;

      this.newFormDespacho();
      this.newFormProvidencia();
      this.newFormEnvolvido();
    });
  }


  filtrarPerfilFecharAbrirPronto(roles) {
    for (var i = 0; i < roles.length; i++) {
      if (roles[i].name == 'admin' || roles[i].name == 'Supervisor Superior' || roles[i].name == 'Supervisor') {
        this.perfilAutorizadoAbrirFecharPronto = true;
        break;
      }
    }
  }

  onFileSelected(event) {
    let vm = this
    this.convertFile(event.target.files[0]).subscribe(base64 => {
      let type = event.target.files[0].type.split("/");
      vm.foto = base64;
      vm.typeFoto = type[1];
    });
  }

  convertFile(file: File): Observable<string> {
    const result = new ReplaySubject<string>(1);
    const fileReader: FileReader = new FileReader();
    fileReader.readAsBinaryString(file);
    fileReader.onload = () => result.next(btoa(fileReader.result.toString()));
    return result;
  }

  async SalvarFotos() {
    let andamento;
    let vm = this;

    if (this.slt.andamento.length > 0) {
      for (let i = 0; i < this.slt.andamento.length; i++) {
        andamento = this.slt.andamento[i];
        andamento.id = andamento.id;
      }
    }

    if (this.foto) {
      let dadosInsert = {
        solicitacao_id: this.slt.id,
        // tipo: 'jpeg',
        tipo: this.typeFoto,
        foto: this.foto,
        // andamento_id:id_andamento
        andamento_id: andamento.id
      }
      vm.exibirSpinnerDeFotoSolicitacao = true;
      await this.apiService.post(URLS.SOLICITACOES_FOTOS.POST_SOLICITACOES_FOTOS, dadosInsert, environment.urlLaravel)
        .subscribe(
          (data) => {
            this.toastr.success('Foto arquivada com sucesso');
            this.carregar_imagens(this.slt.id);
          },
          // (error) => console.log(error)
        );
      this.newFormProvidencia();
    }
  }

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  carregar_imagens(id) {
    let vm = this
    let fotos_resposta = []
    vm.exibirSpinnerDeFotoSolicitacao = true;

    this.apiService.get(URLS.SOLICITACOES_FOTOS.GET_SOLICITACOES_FOTOS, id, environment.urlLaravel)
      .subscribe(
        function (data) {
          fotos_resposta.push(data);
          vm.exibirSpinnerDeFotoSolicitacao = false;
        },
        function (error) {
          vm.exibirSpinnerDeFotoSolicitacao = false;
          // console.log(error);
        });

    vm.fotos = fotos_resposta;
  }
  buscar() {
    let valueSubmit = Object.assign({}, this.filtroForm.value)
    valueSubmit = Object.assign(valueSubmit, { grupos: valueSubmit.grupos.map(v => v.subgrupos.map(v => v.checked === true ? v.id : null).filter(v => v !== null)).filter(v => v.length > 0) })
    valueSubmit = Object.assign(valueSubmit, { situacao: valueSubmit.situacao.map(v => v.checked === true ? v.nome : null).filter(v => v !== null) })
    valueSubmit = Object.assign(valueSubmit, { unidades: valueSubmit.unidades.map(v => v.checked === true ? v : null).filter(v => v !== null) })
    this.respostaFiltro.emit(valueSubmit)
  }

  closeFormularioLateral() {
    this.formularioLateral.status = false
    this.despachos = false
    this.andamentos = false
    this.envolvidos = false
    this.historicos = false
    this.statusFormLateral.emit(this.formularioLateral.status)
  }

  async buscarAgente() {
    this.exibirSpinnerBuscarAgente = true;
    let form = Object.assign({}, this.despachoForm.value)
    let agente = await this.getAgentePorMatricula(form.agente).toPromise();
    if (agente.length > 0) {
      this.agenteFormulario = agente[0];
      this.exibirSpinnerBuscarAgente = false;
      if (agente[0].agentes_status.id != 1) {
        this.exibirSpinnerBuscarAgente = false;
        // this.toastr.warning('Só é permitido despachar para Agentes em status PRONTO.', 'Atenção!');
      }
    }
    else {
      this.exibirSpinnerBuscarAgente = false;
      this.toastr.warning('Agente não encontrado!', 'Atenção');
    }
  }

  async buscarAgenteProvidencia() {
    this.exibirSpinnerBuscarAgenteProvidencia = true;

    const form = this.providenciaForm.value;

    if (!form.matricula) {
      this.toastr.warning('O campo matrícula não pode ser vazio!', 'Atenção');
      this.exibirSpinnerBuscarAgenteProvidencia = false;
      return;
    }

    try {
      const agente = await this.getAgentePorMatricula(form.matricula).toPromise();

      if (!agente || agente.length === 0) {
        this.toastr.warning('Agente não encontrado!', 'Atenção');
        this.exibirSpinnerBuscarAgenteProvidencia = false;
        return;
      }

      if (agente[0].status === '9') {
        this.toastr.warning('Agente não autenticado!', 'Atenção');
        this.exibirSpinnerBuscarAgenteProvidencia = false;
        return;
      }

      this.agenteFormularioProvidencia = agente[0];
      this.exibirSpinnerBuscarAgenteProvidencia = false;
    } catch (error) {
      // console.error(error);
      this.toastr.warning('Erro ao buscar agente!', 'Atenção');
      this.exibirSpinnerBuscarAgenteProvidencia = false;
    }

  }

  buscarSolicitacao($protocolo) {
    let myArray = [];
    const vm = this;

    vm.configurarFormularioProvidencia();
    vm.exibirFormularioDespacho = false;
    vm.exibirFormularioProvidencia = false;
    vm.exibirFormularioEnvolvido = false;

    vm.exibirDropdownProvidencia = true;

    vm.exibirSpinnerListaDeAndamento = true;
    vm.exibirSpinnerListaDeEnvolvido = true;
    vm.exibirSpinnerListaDeHistorico = true;

    vm.andamentos = false;
    vm.envolvidos = false;
    vm.historicos = false;

    vm.getSolicitacaoAtualizada($protocolo).subscribe({
      next: (resposta) => {
        const solicitacao = Array.isArray(resposta) ? resposta[0] : resposta;

        if (!solicitacao && vm.agente == null) {
          vm.toastr.warning('Solicitação não encontrada.', 'Atenção!');
          return;
        }

        vm.solicitacao = solicitacao;
        vm.slt = solicitacao;
        vm.andamentos = solicitacao.andamento || [];
        vm.envolvidos = solicitacao.envolvido || [];

        if (vm.andamentos.length > 0) {
          const ultimoAndamento = vm.andamentos[vm.andamentos.length - 1];

          if (ultimoAndamento.andamentos_tipos) {
            vm.solicitacao.situacao = ultimoAndamento.andamentos_tipos.nome;
            vm.solicitacao.situacaoView = definirNomeAndamentosTiposPorSituacao(vm.solicitacao.situacao);
          }
        } else {
          vm.solicitacao.situacao = 'Abrir';
          vm.solicitacao.situacaoView = definirNomeAndamentosTiposPorSituacao(vm.solicitacao.situacao);
        }

        vm.historicos = [...vm.andamentos].sort((a, b) => {
          return Number(new Date(a.created_at)) - Number(new Date(b.created_at));
        });

        vm.exibirSpinnerListaDeAndamento = false;
        vm.exibirSpinnerListaDeEnvolvido = false;
        vm.exibirSpinnerListaDeHistorico = false;
      },
      error: () => {
        vm.toastr.warning('Solicitação não encontrada. ', 'Atenção!');
        vm.exibirSpinnerListaDeDespacho = false;
        vm.exibirSpinnerListaDeAndamento = false;
        vm.exibirSpinnerListaDeEnvolvido = false;
        vm.exibirSpinnerListaDeHistorico = false;
      },
      complete: () => {
        vm.exibirSpinnerListaDeDespacho = false;
        vm.exibirSpinnerListaDeAndamento = false;
        vm.exibirSpinnerListaDeEnvolvido = false;
        vm.exibirSpinnerListaDeHistorico = false;
      }
    });
  }
  newFormDespacho() {

    this.tipoDespacho.forEach(element => {
      element.checked = false;
    });

    this.despachoForm = this.fb.group(
      {
        tipoDespacho: this.fb.control(this.tipoDespacho, [Validators.required]),
        agente: new FormControl('', {
          validators: [Validators.minLength(7), Validators.maxLength(7)],
          updateOn: 'blur'
        }),
        viatura: new FormControl('', {
          validators: [Validators.minLength(7), Validators.maxLength(7)],
        }),
        observacoes: new FormControl('', {
          validators: [Validators.minLength(10)],
        }),
        tipoContato: new FormControl('', {
          validators: [Validators.minLength(3)],
        }),
        tipo: new FormControl('', {
          validators: [Validators.minLength(3)],
        }),
        unidade: new FormControl('', {
          validators: [Validators.minLength(3)],

        }),
        solicitacaoId: new FormControl('', {
          validators: [Validators.minLength(3)],
        }),
      })
  }

  newFormProvidencia() {
    this.agenteFormularioProvidencia = null;

    //Inicializo as checkbox do despacho desmarcadas
    this.tipoDespacho.forEach(element => {
      element.checked = false;
    });

    const dataAtual = new Date();
    const horaAtual = `${dataAtual.getHours()}:${dataAtual.getMinutes()}`;
    this.providenciaForm = this.fb.group(
      {
        andamentoTipo: this.fb.control('', [Validators.required]),
        despacho_tipo: new FormControl('', [Validators.required]),
        data_andamento: new FormControl(''),
        unidades_nome: new FormControl(''),
        unidades_id: new FormControl(''),
        hora_andamento: new FormControl(''),
        executarFechamento: new FormControl(''),
        data_inicio: [dataAtual.toISOString().split('T')[0], Validators.required],
        data_fim: [dataAtual.toISOString().split('T')[0], Validators.required],
        hora_inicio: [horaAtual, Validators.required],
        hora_fim: [horaAtual, Validators.required],
        matricula: new FormControl('', {
          validators: [Validators.minLength(7), Validators.maxLength(7)],
        }),

        observacoes: new FormControl('', {
          validators: [Validators.maxLength(500)],
        }),
        providenciaRealizada: new FormControl(''),
        tipoFechamento: new FormControl(''),
        motivoFechamento: new FormControl(''),
        placaDoVeiculo: new FormControl(''),
        placas: this.fb.array([])
      })
  }

  validarPlaca(id: number, placa: string): void {
    var resposta = "placa inválida";
    const placaMerSul = /^[a-zA-Z 0-9]{7}$/;

    if (placaMerSul.test(placa)) {

      this.ValidaPlaca = true;
    }

    else {
      this.ValidaPlaca = false;
    }
  }

  novaPlaca(): FormGroup {
    return this.fb2.group({
      placa: ''

    })
  }

  placas(): FormArray {
    return this.providenciaForm.get("placas") as FormArray

  }

  adcionarPlaca() {

    this.placas().push(this.novaPlaca());

  }

  removerPlaca(i: number) {
    this.placas().removeAt(i);
  }
  newFormEnvolvido() {
    this.envolvidoForm = this.fb.group(
      {
        nome: new FormControl(''),
        tipoEnvolvido: new FormControl(''),
        telefone: new FormControl(''),
        email: new FormControl(''),
        cpf: new FormControl('')
      })
  }

  async salvarProvidencia(id) {
    let dados
    let vm = this;
    let formularioLateral: FormGroup = this.providenciaForm
    vm.exibirSpinnerListaDeAndamento = true;
    let agente = null;
    var user = vm.userStorage.getUser();
    let valueSubmit = Object.assign({}, vm.providenciaForm.value)
    valueSubmit.data_inicio = valueSubmit.data_inicio + ' ' + valueSubmit.hora_inicio;
    valueSubmit.data_fim = valueSubmit.data_fim + ' ' + valueSubmit.hora_fim;
    valueSubmit.data_andamento = valueSubmit.data_andamento + ' ' + valueSubmit.hora_andamento;
    valueSubmit.despacho_tipo = valueSubmit.despacho_tipo,
      valueSubmit.solicitacaoId = id;
    dados = valueSubmit;

    if (vm.agenteFormularioProvidencia != null) {
      dados.user_id = vm.agenteFormularioProvidencia.users.id;
      dados.agente_nome = vm.agenteFormularioProvidencia.users.nome;
    }
    else {
      dados.user_id = '';
      dados.agente_nome = '';
    }
    dados.user_id_cadastrante = user.id;
    dados.userLogado = user.nome;
    dados.matriculaUserLogado = user.matricula;
    dados.protocolo = this.solicitacao.protocolo;


    this.validarAndamento(vm, dados)

    if (this.despachoDaProvidencia) {
      this.insertProvidencia(dados);
      if (valueSubmit.executarFechamento === true && valueSubmit.andamentoTipo === '47') {
        dados.andamentoTipo = '66'
        dados.data_andamento = dados.data_fim;
        dados.data_fim = '';
        dados.data_inicio = '';
        dados.observacoes = '';
        dados.hora_inicio = '';
        dados.hora_fim = '';
        dados.providenciaRealizada = '';
        dados.tipoFechamento = '';
        this.insertProvidencia(dados);

      }
      if (valueSubmit.executarFechamento === true && valueSubmit.andamentoTipo === '4') {
        dados.andamentoTipo = '52'
        dados.data_andamento = dados.data_fim;
        dados.data_fim = '';
        dados.data_inicio = '';
        dados.observacoes = '';
        dados.hora_inicio = '';
        dados.hora_fim = '';
        dados.providenciaRealizada = '';
        dados.tipoFechamento = '';
        this.insertProvidencia(dados);

      }
      this.toastr.success('Formulário preenchido com sucesso', 'Sucesso!');
      await this.buscarSolicitacao(valueSubmit.protocolo);
      this.newFormProvidencia();
      this.exibirSpinnerListaDeAndamento = false;
      this.providenciaSalva = true;
      this.statusSalvarProvidencia.emit(this.providenciaSalva);
    } else {
      vm.exibirSpinnerListaDeAndamento = false;
    }
  }

  validarAndamento(vm, dados) {
    dados.data_andamento = vm.dataHoraDoSistema;
    switch (dados.andamentoTipo) {
      case '':
        vm.toastr.warning('O Campo Providência não pode ser vazio. Cadastro não finalizado!', 'Atenção');
        vm.exibirSpinnerListaDeAndamento = false;
        return false;

      case '49':
        this.despachoDaProvidencia = this.despachoService.despachar(vm, dados);
        break;

      case '46':
        this.despachoDaProvidencia = this.despachoNoLocalService.noLocal(vm, dados);
        break;

      case '4':
        this.despachoDaProvidencia = this.despachoAtenderService.atender(vm, dados);
        break;

      case '47':
        this.despachoDaProvidencia = this.despachoNaoAtenderService.naoAtender(vm, dados);
        break;

      case '52':
        this.despachoDaProvidencia = this.despachoFecharService.fechar(vm, dados);
        break;

      case '53':
        this.despachoDaProvidencia = this.despachoDevolverService.devolver(vm, dados);
        break;
    }
  }

  salvarEnvolvido(id) {
    this.exibirSpinnerListaDeEnvolvido = true;
    let valueSubmit = Object.assign({}, this.envolvidoForm.value)
    valueSubmit.solicitacaoId = id;
    let dados
    dados = valueSubmit
    dados.protocolo = this.solicitacao.protocolo;
    if (valueSubmit.nome !== '' && valueSubmit.telefone !== '' && valueSubmit.tipoEnvolvido !== '' && valueSubmit.cpf !== '' && valueSubmit.email !== '') {
      dados = valueSubmit
      this.insertEnvolvido(dados)
      this.toastr.success('Formulário preenchido com sucesso!', 'Sucesso!');
      this.exibirSpinnerListaDeEnvolvido = false;
      this.newFormEnvolvido()
    } else {
      this.toastr.warning('Existem Campos que não foram preenchidos. Cadastro não finalizado!', 'Atenção');
      this.exibirSpinnerListaDeEnvolvido = false;
    }
    this.buscarSolicitacao(valueSubmit.protocolo);
  }

  async insertProvidencia(dados: any,) {
    let dadosInsert = {
      solicitacao_id: dados.solicitacaoId,
      user_id: dados.user_id,
      descricao: dados.observacoes,
      andamentos_tipos_id: dados.andamentoTipo,
      data_inicio: dados.data_inicio,
      data_fim: dados.data_fim,
      providencia_tipo_id: dados.providenciaRealizada,
      andamento_fechamento_tipo_id: dados.tipoFechamento,
      solicitacao_protocolo: dados.protocolo,
      andamento_fechamento_motivo_id: dados.motivoFechamento,
      data_andamento: dados.data_andamento,
      unidades_id: dados.unidades_id,
      unidades_nome: dados.unidades_nome,
      placas: dados.placaDoVeiculo,
      integrado: false,
      protocolo: dados.protocolo,
      despachos_tipos_descricao: dados.despacho_tipo,
      user_id_cadastrante: dados.user_id_cadastrante,
      user_name: dados.userLogado,
      user_matricula: dados.matriculaUserLogado,
      matricula: dados.matricula,
      agentes_id: dados.agentes_id !== null ? dados.agentes_id : dados.user_id_cadastrante,
      agente_nome: dados.agente_nome ? dados.agente_nome : dados.userLogado,
    }
    let vm = this;
    await this.apiService.post(URLS.ANDAMENTOS.GET_ANDAMENTOS, dadosInsert, environment.urlLaravel)
      .subscribe(
        async function (data) {
          //await atualizarSolicitacao(vm, dadosInsert.solicitacao_protocolo, dadosInsert.andamentos_tipos_id);
        },
        function (error) {
          vm.toastr.error('Desculpe não foi possível salvar providência - Cadastro não finalizado', 'Atenção');
          vm.exibirSpinnerListaDeAndamento = false;
          // console.log(error);
        });
  }

  async insertEnvolvido(dados: any) {
    let dadosInsert = {
      nome: dados.nome,
      telefone: dados.telefone,
      email: dados.email,
      cpf: dados.cpf,
      solicitacao_id: dados.solicitacaoId,
      envolvidos_tipo_id: dados.tipoEnvolvido,
      protocolo: dados.protocolo
    }
    this.apiService.post(URLS.SOLICITACAO_ENVOLVIDOS.POST_ANDAMENTOS_ENVOLVIDOS, dadosInsert, environment.urlLaravel)
      .subscribe(
        function (data) {
        },
        function (error) {
          // console.log(error);
        });
  }

  checkbox_encaminhar_agente_unidade(tipo) {

    var g = this.tipoDespacho;

    for (let i = 0; i < this.tipoDespacho.length; i++) {
      if (tipo.label !== this.tipoDespacho[i].label) {
        this.tipoDespacho[i].checked = false
      }
    }
    this.labelTipoEncaminhamento = tipo.label
  }

  openImage(linha: number, coluna: number): void {

    this._album = []
    const fotoClicada = {
      src: 'data:image/png;base64,' + this.fotos[linha][coluna].foto,
      //caption: caption,
      thumb: this.fotos[linha][coluna].foto
    };
    this._album.push(fotoClicada)
    this._lightbox.open(this._album, 0);
  }

  getUnidades() {

    let vm = this
    this.apiService.get(URLS.UNIDADES.GET_UNIDADES_FILTRO, '', environment.urlLaravel)
      .subscribe(
        function (data) {
          let unidadesFiltroTemp: UnidadeFiltro[] = Array();
          for (let i: number = 0; i < data.length; i++) {
            unidadesFiltroTemp[i] = data[i];
            unidadesFiltroTemp[i].id = data[i].id;
            unidadesFiltroTemp[i].sigla = data[i].sigla;
            unidadesFiltroTemp[i].checked = false;
          }
          vm.unidades = unidadesFiltroTemp

        },
        function (error) {
          // console.log(error);
        });

  }

  getDespachosTipos() {
    let vm = this
    this.apiService.get(URLS.DESPACHOS_TIPOS.GET_DESPACHOS_TIPOS, '', environment.urlLaravel)
      .subscribe(
        function (data) {
          let DespachosTipoTemp: DespachoTipo[] = Array()
          for (let i: number = 0; i < data.length; i++) {
            DespachosTipoTemp[i] = data[i]
            DespachosTipoTemp[i].checked = false
          }
          vm.despachosTipos = DespachosTipoTemp
        },
        function (error) {
          // console.log(error);
        });
  }

  getProvidenciasTipos() {
    let vm = this
    this.apiService.get(URLS.PROVIDENCIAS_TIPOS.GET_PROVIDENCIAS_TIPOS, '', environment.urlLaravel)
      .subscribe(
        function (data) {
          let ProvidenciaTipoTemp: ProvidenciaTipo[] = Array()
          for (let i: number = 0; i < data.length; i++) {
            ProvidenciaTipoTemp[i] = data[i]
            ProvidenciaTipoTemp[i].checked = false
          }
          vm.providenciasTipos = ProvidenciaTipoTemp
        },
        function (error) {
          // console.log(error);
        });
  }

  getAndamentosTipos() {
    let vm = this
    this.exibirSpinnerFormularioDeAndamento = true;
    this.apiService.get(URLS.ANDAMENTOS.GET_ANDAMENTOS_TIPOS, '', environment.urlLaravel)
      .subscribe(
        function (data) {
          let AndamentosTipoTemp: AndamentoTipo[] = Array()
          for (let i: number = 0; i < data.length; i++) {
            if (data[i].visivel === '1') {
              AndamentosTipoTemp.push(data[i])
            }
          }
          vm.validarDropdownAndamentoTipo(AndamentosTipoTemp);
          vm.listaAndamentosTipos = AndamentosTipoTemp;
          vm.exibirSpinnerFormularioDeAndamento = false;
          vm.exibirDropdownProvidencia = true;
        },
        function (error) {
          // console.log(error);
        });
  }

  validarDropdownAndamentoTipo($andamentosTipos) {

    let vm = this
    let andamentoTipoValidado: AndamentoTipo[] = Array()

    switch (vm.solicitacao.situacao) {
      case 'Abrir': {
        for (let i: number = 0; i < $andamentosTipos.length; i++) {
          if ($andamentosTipos[i].nome === 'Despachar' || $andamentosTipos[i].nome === 'Reclassificar' || $andamentosTipos[i].nome === 'Não Atender') {
            andamentoTipoValidado.push($andamentosTipos[i])
          }
        }
        vm.andamentosTipos = andamentoTipoValidado
        break;
      }
      case 'Aceitar': {
        for (let i: number = 0; i < $andamentosTipos.length; i++) {
          if ($andamentosTipos[i].nome === 'No local' || $andamentosTipos[i].nome === 'Devolver') {
            andamentoTipoValidado.push($andamentosTipos[i])
          }
        }
        vm.andamentosTipos = andamentoTipoValidado
        break;
      }
      case 'Despachar': {
        let x = vm.andamentos.length - 1;
        for (let i: number = 0; i < $andamentosTipos.length; i++) {
          if ($andamentosTipos[i].nome === 'No local' || $andamentosTipos[i].nome === 'Atender' || $andamentosTipos[i].nome === 'Não Atender' || $andamentosTipos[i].nome === 'Devolver') {
            andamentoTipoValidado.push($andamentosTipos[i])
          }
          if ($andamentosTipos[i].nome === 'Despachar' && vm.andamentos[x].unidades_nome) {

            // andamentoTipoValidado = andamentoTipoValidado.filter(item => item.descricao != 'No local');

            andamentoTipoValidado.push($andamentosTipos[i]);

          }
        }
        vm.andamentosTipos = andamentoTipoValidado
        break;
      }
      case 'No local': {
        for (let i: number = 0; i < $andamentosTipos.length; i++) {
          if ($andamentosTipos[i].nome === 'Atender' || $andamentosTipos[i].nome === 'Não Atender' || $andamentosTipos[i].nome === 'Devolver') {
            andamentoTipoValidado.push($andamentosTipos[i])
          }
        }
        vm.andamentosTipos = andamentoTipoValidado
        break;
      }
      case 'Atender': {
        for (let i: number = 0; i < $andamentosTipos.length; i++) {
          if ($andamentosTipos[i].nome === 'Fechar') {
            andamentoTipoValidado.push($andamentosTipos[i])
          }
        }
        vm.andamentosTipos = andamentoTipoValidado
        break;
      }
      case 'Não Atender': {
        for (let i: number = 0; i < $andamentosTipos.length; i++) {
          if ($andamentosTipos[i].nome === 'Fechar') {
            andamentoTipoValidado.push($andamentosTipos[i])
          }
        }
        vm.andamentosTipos = andamentoTipoValidado
        break;
      }
      case 'Fechar': {
        vm.andamentosTipos = $andamentosTipos
        break;
      }
      case 'Cancelar': {
        vm.andamentosTipos = $andamentosTipos
        break;
      }
      case 'Devolver': {
        for (let i: number = 0; i < $andamentosTipos.length; i++) {
          if ($andamentosTipos[i].nome === 'Despachar' || $andamentosTipos[i].nome === 'Reclassificar') {
            andamentoTipoValidado.push($andamentosTipos[i])
          }
        }
        vm.andamentosTipos = andamentoTipoValidado
        break;
      }
      case 'Reiterar': {
        vm.andamentosTipos = $andamentosTipos
        break;
      }
      case 'Reclassificar': {
        vm.andamentosTipos = $andamentosTipos
        break;
      }
    }


    vm.andamentosTipos.sort((a, b) => a['ordem'] > b['ordem'] ? 1 : a['ordem'] === b['ordem'] ? 0 : -1);


  }

  getAndamentosFechamentosTipos() {
    let vm = this
    this.apiService.get(URLS.ANDAMENTOS_FECHAMENTOS_TIPOS.GET_ANDAMENTOS_FECHAMENTOS_TIPOS, '', environment.urlLaravel)
      .subscribe(
        function (data) {
          let AndamentoFechamentoTipoTemp: AndamentoFechamentoTipo[] = Array()
          for (let i: number = 0; i < data.length; i++) {
            AndamentoFechamentoTipoTemp[i] = data[i]
            AndamentoFechamentoTipoTemp[i].checked = false
          }
          vm.andamentosFechamentosTipos = AndamentoFechamentoTipoTemp
        },
        function (error) {
          // console.log(error);
        });
  }

  getAndamentosFechamentosMotivos() {
    let vm = this
    this.apiService.get(URLS.ANDAMENTOS_FECHAMENTOS_MOTIVOS.GET_ANDAMENTOS_FECHAMENTOS_MOTIVOS, '', environment.urlLaravel)
      .subscribe(
        function (data) {
          let AndamentoFechamentoMotivoTemp: AndamentoFechamentoMotivo[] = Array()
          for (let i: number = 0; i < data.length; i++) {
            AndamentoFechamentoMotivoTemp[i] = data[i]
            AndamentoFechamentoMotivoTemp[i].checked = false
          }
          vm.andamentosFechamentosMotivos = AndamentoFechamentoMotivoTemp
        },
        function (error) {
          // console.log(error);
        });
  }

  getTiposDeEnvolvimento() {
    let vm = this
    this.apiService.get(URLS.SOLICITACAO_ENVOLVIDOS.GET_SOLICITACAO_ENVOLVIDOS_TIPOS, '', environment.urlLaravel)
      .subscribe(
        function (data) {
          let EnvolvidosTipoTemp: EnvolvimentosTipo[] = Array()
          for (let i: number = 0; i < data.length; i++) {
            EnvolvidosTipoTemp[i] = data[i]
            EnvolvidosTipoTemp[i].checked = false
          }
          vm.tiposEnvolvimento = EnvolvidosTipoTemp
        },
        function (error) {
          // console.log(error);
        });
  }

  getAgentePorMatricula(matricula) {
    return this.apiService.get(URLS.AGENTES.GET_AGENTES_POR_MATRICULA, matricula, environment.urlLaravel);
  }

  getSolicitacaoAtualizada($protocolo) {
    return this.apiService.get(URLS.SOLICITACOES.GET_SOLICITACOES_COM_ANDAMENTOS_E_DESPACHO_POR_PROTOCOLO + '/' + $protocolo + '/andamentos', '', environment.urlLaravel);
  }

  configurarFormularioProvidencia() {

    this.atender = false;
    this.no_local = false;
    this.nao_atender = false;
    this.despachar = false;
    this.reiterar = false;
    this.cancelar = false;
    this.fechar = false;
    this.devolver = false;
    this.reclassificar = false;

    this.exibirCheckBoxDespachar = false;
    this.exibirCheckBoxExecutarFechamento = false;
    this.exibirDropdownProvidencia = false;

    this.labelTipoEncaminhamento = '';

    if (!isNullOrUndefined(this.providenciaForm)) {
      //Atender
      if (this.providenciaForm.value.andamentoTipo === '4') {
        this.atender = true;
        this.exibirCheckBoxExecutarFechamento = true;
        this.exibirDropdownProvidencia = true;

      }
      //No local
      if (this.providenciaForm.value.andamentoTipo === '46') {
        this.no_local = true;
        this.exibirDropdownProvidencia = true;
      }

      //Não Atender
      if (this.providenciaForm.value.andamentoTipo === '47') {
        this.nao_atender = true;
        this.exibirCheckBoxExecutarFechamento = true;
        this.exibirDropdownProvidencia = true;

      }

      //DESPACHAR
      if (this.providenciaForm.value.andamentoTipo === '49') {
        this.despachar = true;
        this.exibirCheckBoxDespachar = true;
        this.exibirDropdownProvidencia = true;
      }

      //Reiterar
      if (this.providenciaForm.value.andamentoTipo === '50') {
        this.reiterar = true;
        this.exibirDropdownProvidencia = true;
      }

      //Cancelar
      if (this.providenciaForm.value.andamentoTipo === '51') {
        this.cancelar = true;
        this.exibirDropdownProvidencia = true;
      }

      //Fechar
      if (this.providenciaForm.value.andamentoTipo === '52') {
        this.fechar = true;
        this.exibirDropdownProvidencia = true;
      }

      //Devolver
      if (this.providenciaForm.value.andamentoTipo === '53') {
        this.devolver = true;
        this.exibirDropdownProvidencia = true;
      }

      //Reclassificar
      if (this.providenciaForm.value.andamentoTipo === '54') {
        this.reclassificar = true;
        this.exibirDropdownProvidencia = true;
      }
    }
  }



  fecharProntoAgente(agente) {
    var valor = agente.pronto == '0' ? '0' : '1';
    var deslogar = {
      'agente_id': agente.id,
      'pronto': valor
    };

    this.unidadeAutorizadaAbrirFecharPronto = (agente.unidade_id === this.usuarioLogado.agentes.unidade_id) ? true : false;

    if (!this.perfilAutorizadoAbrirFecharPronto) {
      return this.toastr.success(`Usuário logado não pode realizar essa ação`, `Atenção !`);
    }

    this.apiService.post(URLS.AGENTES.POST_FECHAR_PRONTO_AGENTE, deslogar, environment.urlLaravel)
      .subscribe((data) => {
        if (data['original'] !== null) {
          var texto = data['original']['pronto'] == '0' ? 'fechado' : 'aberto';
          this.toastr.success(`Pronto do agente ${texto} com sucesso`, `Atenção !`);
        } else {
          this.toastr.success(`Erro inesperado !`, `Atenção !`);
        }
      }
      )
  }
}






function validaPlaca(vm, dados) {

  const placaMerSul = /^[a-zA-Z 0-9]{7}$/;
  var name;


  dados.placas.forEach(element => {

    name = element.placa
    if (placaMerSul.test(name)) {

      dados.ValidaPlaca = true;
    } else {

      vm.toastr.warning('Placa invalida - Cadastro não finalizado', 'Atenção');
      vm.exibirSpinnerListaDeAndamento = false;
      vm.retorno = false;
      return
    }
  });
  dados.placaDoVeiculo = vm.pipeTransformaArrayDeObjetosEmString.transform(dados.placas);
}



// WEBPACK FOOTER //
// ./src/app/shared/formulario-lateral/formulario-lateral.component.ts